<template>
  <b-card border-variant="light" class="my-2">

    <b-row class="my-1">
      <b-col>
        <h5>Evacuaciones Intestinales</h5>
      </b-col>
    </b-row>


    <b-row align-v="center" class="ml-1">

      <b-col>
        <v-select
          placeholder="Seleccione una o mas opciones"
          :options="evacuacionesOpts"
          :reduce="option => option"
          label="text"
          :multiple="true"
          taggable
          @input="newArray => evacuaciones.selected = onAddNewOpt(newArray)"
        />
      </b-col>
    </b-row>



    <div v-if="diarrea.active">

      <b-row class="ml-2 my-1">
        <b-col>
          <hr >
          <h6>Diarrea</h6>
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-4">
          <div for="">Frecuencia por dia:</div>
        </b-col>

        <b-col class="col-3">
          <v-select
            placeholder="0"
            :options="diarreaFrecuenciaDiasOpts"
            :reduce="option => option"
            label="text"
            v-model="diarrea.frecuenciaDia"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-3">
          <div>Caracteristicas:</div>
        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una o mas opciones"
            :options="diarreaCaracteristicasOpts"
            :reduce="option => option"
            label="text"
            :multiple="true"
            taggable
            @input="newArray => diarrea.caracteristicas = onAddNewOpt(newArray)"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-3">
          <div>Volumen:</div>
        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una opcion"
            :options="diarreaVolumenOpts"
            :reduce="option => option"
            label="text"
            v-model="diarrea.volumen"
          />
        </b-col>
      </b-row>


      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-3">
          <div>Dolor Abdominal:</div>
        </b-col>

        <b-col>
          <b-form-checkbox 
            switch 
            v-model="diarrea.dolorAbdominal"
          >
            <span class="score">
              {{ diarrea.dolorAbdominal ? 'Si' : 'No' }}
            </span>
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-3">
          <div>Sintomas Asociados:</div>

        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una o mas opciones"
            :options="diarreaSintomasOpts"
            :reduce="option => option"
            label="text"
            :multiple="true"
            taggable
            @input="newArray => diarrea.sintomas = onAddNewOpt(newArray)"
          />
        </b-col>
      </b-row>
    </div>


    <div v-if="constipacion.active">
      <b-row class="ml-2 my-1">
        <b-col>
          <hr >
          <h6>Constipacion</h6>
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-4">
          <div for="">Frecuencia:</div>
        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una opcion"
            :options="constipacionFrecuenciaOpts"
            :reduce="option => option"
            label="text"
            v-model="constipacion.frecuencia"
          />
        </b-col>
      </b-row>


      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-3">
          <div for="">Caracteristicas / Escala de bristol:</div>
        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una opcion"
            :options="bristolOpts"
            :reduce="option => option"
            label="text"
            v-model="constipacion.caracteristicas"
          />
        </b-col>
      </b-row>


      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-4">
          <div>Dolor en region anal:</div>
        </b-col>

        <b-col class="col-2">
          <b-form-checkbox 
            switch 
            v-model="constipacion.dolorAnal"
          >
            <span class="score">
              {{ constipacion.dolorAnal ? 'Si' : 'No' }}
            </span>
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-3">
          <div for="">Sangrado:</div>
        </b-col>

        <b-col class="">
          <v-select
            placeholder="Seleccione una o mas opciones"
            :options="constipacionSangradoOpts"
            :reduce="option => option"
            label="text"
            :multiple="true"
            taggable
            @input="newArray => constipacion.sangrado = onAddNewOpt(newArray)"
          />
        </b-col>
      </b-row>
    </div>

    <div v-if="melenas.active">
      <b-row class="ml-2 my-1">
        <b-col>
          <hr >
          <h6>Melenas</h6>
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-4">
          <div for="">Cantidad:</div>
        </b-col>

        <b-col class="col-3">
          <v-select
            placeholder="0"
            :options="diarreaFrecuenciaDiasOpts"
            :reduce="option => option.value"
            label="text"
            v-model="melenas.cuantas"
          />
        </b-col>
      </b-row>


      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-4">
          <div for="">Desde cuando:</div>
        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una opcion"
            :options="melenasDesdeOpts"
            :reduce="option => option"
            label="text"
            v-model="melenas.desde"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-4">
          <div for="">Sintomas Asociados:</div>
        </b-col>

        <b-col>
          <b-form-input
            v-model="melenas.sintomas"
            placeholder="Ingrese la descripción"
          />
        </b-col>
      </b-row>

    </div>

    <div v-if="hematoquesia.active">
      <b-row class="ml-2 my-1">
        <b-col>
          <hr >
          <h6>Hematoquesia</h6>
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-4">
          <div for="">Cantidad:</div>
        </b-col>

        <b-col class="col-3">
          <v-select
            placeholder="0"
            :options="diarreaFrecuenciaDiasOpts"
            :reduce="option => option.value"
            label="text"
            v-model="hematoquesia.cuantas"
          />
        </b-col>
      </b-row>


      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-4">
          <div for="">Desde cuando:</div>
        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una opcion"
            :options="melenasDesdeOpts"
            :reduce="option => option"
            label="text"
            v-model="hematoquesia.desde"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-4">
          <div for="">Sintomas Asociados:</div>
        </b-col>

        <b-col>
          <b-form-input
            v-model="hematoquesia.sintomas"
            placeholder="Ingrese la descripción"
          />
        </b-col>
      </b-row>

    </div>

    <div v-if="rectorragia.active">
      <b-row class="ml-2 my-1">
        <b-col>
          <hr >
          <h6>Rectorragia</h6>
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-4">
          <div for="">Cantidad:</div>
        </b-col>

        <b-col class="col-3">
          <v-select
            placeholder="0"
            :options="diarreaFrecuenciaDiasOpts"
            :reduce="option => option.value"
            label="text"
            v-model="rectorragia.cuantas"
          />
        </b-col>
      </b-row>


      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-4">
          <div for="">Desde cuando:</div>
        </b-col>

        <b-col>
          <v-select
            placeholder="Seleccione una opcion"
            :options="melenasDesdeOpts"
            :reduce="option => option"
            label="text"
            v-model="rectorragia.desde"
          />
        </b-col>
      </b-row>

      <b-row align-v="center" class="ml-3 my-1">
        <b-col class="col-4">
          <div for="">Sintomas Asociados:</div>
        </b-col>

        <b-col>
          <b-form-input
            v-model="rectorragia.sintomas"
            placeholder="Ingrese la descripción"
          />
        </b-col>
      </b-row>

    </div>

  </b-card>
</template>

<script>
import vSelect from "vue-select";
import { addNewOpt } from '@/shared/helpers';

export default {
  name: "SintomasEvacuaciones",

  components: {
    vSelect
  },

  data(){
    return {

      evacuaciones:{
        selected: [],
        diarrea:null,
        constipacion:null,
        melenas:null,
        hematoquesia:null,
        rectorragia:null
      },


      diarrea:{
        active:false,
        frecuenciaDia: 0,
        caracteristicas:[],
        volumen: [],
        dolorAbdominal:false,
        sintomas:[]
      },

      constipacion:{
        active:false,
        frecuencia: null,
        caracteristicas: null,
        dolorAnal:false,
        sangrado:[]
      },

      melenas:{
        active:false,
        cuantas:0,
        desde:null,
        sintomas:'',
      },

      hematoquesia:{
        active:false,
        cuantas:0,
        desde:null,
        sintomas:'',
      },

      rectorragia:{
        active:false,
        cuantas:0,
        desde:null,
        sintomas:'',
      },

      evacuacionesOpts: [
        { value: 'normales',     text: 'normales' },
        { value: 'diarrea',      text: 'diarrea' },
        { value: 'constipacion', text: 'constipacion' },
        { value: 'melenas',      text: 'melenas' },
        { value: 'hematoquesia', text: 'hematoquesia' },
        { value: 'rectorragia',  text: 'rectorragia' },
      ],


      diarreaFrecuenciaDiasOpts: [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' },
        { value: 7, text: '7' },
        { value: 8, text: '8' },
        { value: 9, text: '9' },
        { value: 10, text: '10 o mas' },
      ],

      diarreaCaracteristicasOpts: [
        { value: 'liquidas', text: 'liquidas' },
        { value: 'blandas',  text: 'blandas' },
        { value: 'moco',     text: 'moco' },
        { value: 'mal_olor', text: 'mal olor' },
        { value: 'presencia_de_sangre', text: 'presencia de sangre' },
      ],

      diarreaSintomasOpts: [
        { value: 'meteorimos',       text: 'meteorimos' },
        { value: 'flatulencias',     text: 'flatulencias' },
        { value: 'nauseas',          text: 'nauseas' },
        { value: 'vomito',           text: 'vomito' },
        { value: 'fiebre',           text: 'fiebre' },
        { value: 'malestar_general', text: 'malestar general' },
        { value: 'astenia',          text: 'astenia' },
        { value: 'mialgias',         text: 'mialgias' },
        { value: 'altralgias',       text: 'altralgias' },
      ],


      diarreaVolumenOpts: [
        { value: 'abundantes', text: 'abundantes' },
        { value: 'escasas',    text: 'escasas' },
      ],


      constipacionFrecuenciaOpts:[
        { value: 'dias',    text: 'dias' },
        { value: 'semanas', text: 'semanas' },
      ],

      constipacionSangradoOpts:[
        { value: 'mancha_papel_higienico',       text: 'mancha papel higienico' },
        { value: 'sangrado_evidente_en_inodoro', text: 'sangrado evidente en inodoro' },
      ],

      bristolOpts: [
        { value: 'tipo_1', text: 'Tipo 1: heces separadas duras, difíciles de evacuar' },
        { value: 'tipo_2', text: 'Tipo 2: forma de salchicha gruesa y larga, con grietas en la superficie' },
        { value: 'tipo_3', text: 'Tipo 3: forma de salchicha con grietas en la superficie' },
        { value: 'tipo_4', text: 'Tipo 4: forma de salchicha lisa y suave' },
        { value: 'tipo_5', text: 'Tipo 5: bolitas suaves con bordes definidos (heces fáciles de pasar)' },
        { value: 'tipo_6', text: 'Tipo 6: trozos suaves y esponjosos con bordes irregulares' },
        { value: 'tipo_7', text: 'Tipo 7: líquido, sin trozos sólidos (diarrea)' },
      ],


      melenasDesdeOpts: [
        { value: 'hace_dias',    text: 'hace dias' },
        { value: 'hace_semanas', text: 'hace semanas' },
        { value: 'hace_meses',   text: 'hace meses' },
      ]
    }
  },

  methods: {
    onAddNewOpt( newValue ){
      return addNewOpt( newValue );
    }
  },

  watch: {

    evacuaciones:{
      deep: true,
      handler(newValue) {
        this.diarrea.active      = newValue.selected.some( item => item.value === 'diarrea' )
        this.constipacion.active = newValue.selected.some( item => item.value === 'constipacion' )
        this.melenas.active      = newValue.selected.some( item => item.value === 'melenas' )
        this.hematoquesia.active = newValue.selected.some( item => item.value === 'hematoquesia' )
        this.rectorragia.active  = newValue.selected.some( item => item.value === 'rectorragia' )

        this.$store.commit("setGastro", { evacuaciones:newValue });
      }
    },

    diarrea:{
      deep: true,
      handler(newValue) {
        this.evacuaciones.diarrea = newValue;
      },
    },

    constipacion:{
      deep: true,
      handler(newValue) {
        this.evacuaciones.constipacion = newValue;
      },
    },

    hematoquesia: {
      deep: true,
      handler(newValue) {
        this.evacuaciones.hematoquesia = newValue;
      },
    },

    rectorragia: {
      deep: true,
      handler(newValue) {
        this.evacuaciones.rectorragia = newValue;
      },
    }
  }
}
</script>

